import React from 'react';

export function Radio({ label, description, disabled = false, className = '', ...rest }) {
  return (
    <label className={['sp-check', 'sp-check--radio', disabled && 'sp-check--disabled', className].filter(Boolean).join(' ')}>
      <input type="radio" disabled={disabled} {...rest} />
      <span className="sp-check__box"><span className="sp-check__mark" /></span>
      <span className="sp-check__text">
        {label}
        {description && <span className="sp-check__desc">{description}</span>}
      </span>
    </label>
  );
}
